export default __webpack_public_path__ + "static/media/login_photo.fefeff9c.png";